
(() => {
  const language = document.documentElement.lang
    .toLowerCase()
    .split("-")[0];

  if (language !== "en") return;

  const API_URL =
    "https://api.frankfurter.dev/v2/rate/USD/COP";

  const CACHE_KEY = "mycreationsw_usd_cop_rate_v1";
  const CACHE_DURATION = 24 * 60 * 60 * 1000;

  let copPerUsd = null;
  let scheduled = false;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function getCachedRate() {
    try {
      const cached = JSON.parse(
        localStorage.getItem(CACHE_KEY) || "null"
      );

      if (
        cached &&
        Number.isFinite(cached.rate) &&
        cached.rate > 0 &&
        Number.isFinite(cached.savedAt)
      ) {
        return cached;
      }
    } catch (error) {
      console.warn("Currency cache unavailable:", error);
    }

    return null;
  }

  function saveRate(rate, date) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          rate,
          date,
          savedAt: Date.now()
        })
      );
    } catch (error) {
      console.warn("Could not save exchange rate:", error);
    }
  }

  function formatUSD(cents, negative = false) {
    const amount = Number(cents) / 100 / copPerUsd;

    if (!Number.isFinite(amount)) return null;

    return (negative ? "-" : "") +
      "US" + formatter.format(amount);
  }

  function convertElement(el) {
    if (!copPerUsd) return;

    const raw =
      el.getAttribute("data-cop-cents") ??
      el.getAttribute("data-price-cents");

    if (!raw || !/^\d+$/.test(raw)) return;

    const negative =
      el.getAttribute("data-price-negative") === "true";

    const formatted = formatUSD(raw, negative);

    if (formatted === null) return;

    const target = el.matches("text-component")
      ? el.querySelector("bdi")
      : el;

    if (!target) return;

    if (target.textContent.trim() !== formatted) {
      target.textContent = formatted;
    }
  }

  function convertPrices() {
    if (!copPerUsd) return;

    document.querySelectorAll(
      "[data-cop-cents], [data-price-cents]"
    ).forEach(convertElement);
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      convertPrices();
    });
  }

  async function updateExchangeRate() {
    const cached = getCachedRate();

    // Mostrar la última tasa conocida mientras se actualiza.
    if (cached) {
      copPerUsd = cached.rate;
      convertPrices();
    }

    // Evitar consultar la API si la tasa sigue vigente.
    if (
      cached &&
      Date.now() - cached.savedAt < CACHE_DURATION
    ) {
      return;
    }

    try {
      const response = await fetch(API_URL, {
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const rate = Number(data.rate);

      if (
        data.base !== "USD" ||
        data.quote !== "COP" ||
        !Number.isFinite(rate) ||
        rate <= 0
      ) {
        throw new Error("Invalid exchange rate response");
      }

      copPerUsd = rate;
      saveRate(rate, data.date);

      convertPrices();

      console.info(
        `USD/COP reference rate: ${rate} (${data.date})`
      );
    } catch (error) {
      console.warn(
        "Exchange rate unavailable. Using cached rate if available.",
        error
      );
    }
  }

  // Observar cambios de cantidad, descuentos y carrito AJAX.
  const observer = new MutationObserver(scheduleUpdate);

  function initialize() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        "data-cop-cents",
        "data-price-cents",
        "data-price-negative"
      ]
    });

    updateExchangeRate();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
